import React, { useState } from "react";
import { useAuth } from "@/contexts/AuthContext";
import { useLang } from "@/lib/i18n";
import { api } from "@/lib/api";
import { toast } from "@/components/ui/sonner";
import { MailWarning } from "lucide-react";

export const EmailVerifyBanner = () => {
  const { user } = useAuth();
  const { t } = useLang();
  const [sending, setSending] = useState(false);

  if (!user || user.email_verified) return null;

  const resend = async () => {
    setSending(true);
    try {
      await api.post("/auth/resend-verification", { origin_url: window.location.origin });
      toast.success(t("resend_sent"));
    } catch (e) {
      toast.error(e.response?.data?.detail || e.message);
    } finally {
      setSending(false);
    }
  };

  return (
    <div
      data-testid="email-verify-banner"
      className="bg-signal/10 border-b border-signal/30 px-4 md:px-8 py-2.5 flex flex-wrap items-center justify-center gap-x-3 gap-y-1 font-mono text-xs text-signal"
    >
      <MailWarning className="w-4 h-4 shrink-0" />
      <span className="text-white/80">{t("verify_banner")}</span>
      <button
        data-testid="resend-verify-btn"
        onClick={resend}
        disabled={sending}
        className="underline underline-offset-2 hover:text-white transition-colors disabled:opacity-50"
      >
        {sending ? "…" : t("resend_confirm")}
      </button>
    </div>
  );
};
